<template>
  <div v-if="isInStock && quantity" class="flex items-center !p-0 text-sm">
    <div class="bg-green mr-1 size-4 rounded-full bg-[color:var(--color-success)]"></div>
    <span>{{ $t("common.labels.in_stock") }}</span>
  </div>

  <div v-else-if="!isAvailable" class="flex items-center !p-0 text-sm">
    <div class="bg-green mr-1 size-4 rounded-full bg-[color:var(--color-danger)]"></div>

    <span class="mx-1 inline-block min-w-5 text-center">
      {{ $t("common.messages.product_no_longer_available") }}
    </span>
  </div>

  <div v-else class="flex items-center !p-0 text-sm">
    <div class="bg-green mr-1 size-4 rounded-full bg-[#fd9a00]"></div>

    <span class="mx-1 inline-block min-w-5 text-center">
      {{ $t("common.messages.product_out_of_stock") }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { MAX_DISPLAY_IN_STOCK_QUANTITY } from "@/core/constants";

interface IProps {
  isInStock?: boolean;
  isAvailable?: boolean;
  isDigital?: boolean;
  quantity?: number | null;
  size?: "xs" | "sm" | "md" | "lg";
  textEnabled?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isAvailable: true,
  quantity: null,
  size: "sm",
  textEnabled: true,
});

const inStockQuantityLabel = computed<string>(() =>
  props.quantity && props.quantity > MAX_DISPLAY_IN_STOCK_QUANTITY
    ? `${MAX_DISPLAY_IN_STOCK_QUANTITY}+`
    : props.quantity!.toString(),
);
</script>
